import { inject } from '@angular/core';
import { HttpHandlerFn, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { SpinnerStore } from '@program-suite/data-common';

export function spinnerInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const spinnerStore = inject(SpinnerStore);

  spinnerStore.incrementActiveRequests(); // Increment active requests

  return next(req).pipe(
    finalize(() => {
      spinnerStore.decrementActiveRequests(); // Decrement active requests
    })
  );
}